import Tools from '@/components/tools/Tools'
// import EmployeeRepository from '@/shared/http/repositories/business/employee.js'
// import { loading } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'

export default {
  name: 'paneldetails',
  mixins: [ ActionsForm ],
  props: ['dataDetails', 'totalProp', 'totalFuncionarioDespesas'],
  mounted () {
    this.GetSubCategoria()
    this.GetStatusDespesa()
  },
  data () {
    return {
      dataValues: {},
      dataFormSearch: {
        categoria: null,
        situacao: null
      },
      dataStatusDespesa: [],
      dataEnumCategoria: [],
      dataSubCategoriaVeiculo: [],
      dataSubCategoria: []
    }
  },
  computed: {
    statusFrase () {
      var s = this.dataDetails ? this.dataDetails.statusDespesa : null
      switch (s) {
        case 9: return 'AG. APROVAÇÃO TÉCNICO'
        case 1: return 'AG. APROVAÇÃO COORDENADOR'
        case 2: return 'AG. APROVAÇÃO CONTROLADORIA'
        case 3: return 'AG. APROVAÇÃO DIRETORIA'
        default: return 'AG. APROVAÇÃO COORDENADOR'
      }
    }
  },
  methods: {
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    onClear () {
      Object.keys(this.dataFormSearch).forEach((Element) => {
        this.dataFormSearch[Element] = null
      })
    },
    GetSubCategoria () {
      MiscellaneousExpensesRepository.GetAllSubCategoria()
        .then((Response) => {
          this.dataSubCategoria = Response.data
        })
        .catch((Error) => {
          console.error(Error)
        })
    },
    GetStatusDespesa () {
      MiscellaneousExpensesRepository.GetStatusDespesasDiversos()
        .then((Response) => {
          this.dataStatusDespesa.push(Response.data[1], Response.data[2], Response.data[3], Response.data[9])
        })
        .catch((Error) => {
          console.error(Error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/paneldetails/paneldetails.js